export default __webpack_public_path__ + "images/slide_10.jpeg?597199c238dbd9253104e0a48fd5c19a";